(() => {
  const SELECTOR = '[data-kz-flight]';
  const GLOBAL_KEY = 'KizilcoScrollFlights';
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].initAll === 'function') {
    window[GLOBAL_KEY].initAll();
    return;
  }

  const documentTop = (element) => {
    let top = 0;
    let node = element;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  };

  function initFlight(flight) {
    if (!flight || flight.dataset.kzFlightInitialized === 'true') return;
    flight.dataset.kzFlightInitialized = 'true';

    const rail = flight.querySelector('[data-kz-flight-rail]');
    const rocket = flight.querySelector('[data-kz-flight-rocket]');
    const plume = flight.querySelector('[data-kz-flight-plume]');
    const mode = flight.dataset.kzFlightMode || 'viewport';
    const reverse = flight.dataset.kzFlightDirection === 'reverse';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!rail || !rocket || reduceMotion) return;

    let frame = 0;
    let previousScrollY = Math.max(window.scrollY, 0);
    let scrollDirection = 1;

    const update = () => {
      frame = 0;
      const scrollY = Math.max(window.scrollY, 0);
      if (scrollY !== previousScrollY) {
        scrollDirection = scrollY > previousScrollY ? 1 : -1;
        previousScrollY = scrollY;
      }
      const rect = flight.getBoundingClientRect();
      let progress;

      if (mode === 'hero') {
        const zone = flight.closest('[data-kzh-hero]') || flight.parentElement;
        const startScroll = Math.max(documentTop(zone) - window.innerHeight * 0.2, 0);
        const distance = Math.max(zone.offsetHeight * 0.68, window.innerHeight * 0.6, 1);
        progress = clamp((window.scrollY - startScroll) / distance, 0, 1);
      } else {
        const startLine = window.innerHeight * 0.9;
        const finishLine = window.innerHeight * 0.26;
        progress = clamp((startLine - rect.top) / Math.max(startLine - finishLine, 1), 0, 1);
      }

      const railWidth = Math.max(rail.clientWidth, 1);
      const rocketWidth = Math.max(rocket.offsetWidth, 1);
      const plumeWidth = plume ? plume.offsetWidth : 320;
      const exitStart = 0.84;
      const trackProgress = clamp(progress / exitStart, 0, 1);
      const exitProgress = clamp((progress - exitStart) / (1 - exitStart), 0, 1);
      const exitTravel = plumeWidth + rocketWidth * 1.55;
      const position = reverse
        ? railWidth - trackProgress * railWidth - exitProgress * exitTravel
        : -rocketWidth + trackProgress * railWidth + exitProgress * exitTravel;
      const opacity = clamp(progress / 0.018, 0, 1) * clamp((1 - progress) / 0.025, 0, 1);

      flight.style.setProperty('--kz-flight-progress', `${trackProgress * 100}%`);
      flight.style.setProperty('--kz-flight-position', `${position}px`);
      flight.style.setProperty('--kz-flight-opacity', `${opacity}`);
      flight.style.setProperty('--kz-flight-facing', `${reverse ? -scrollDirection : scrollDirection}`);
    };

    const requestUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();

    flight._kzFlightCleanup = () => {
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      if (frame) cancelAnimationFrame(frame);
      delete flight._kzFlightCleanup;
      delete flight.dataset.kzFlightInitialized;
    };
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(SELECTOR)) initFlight(scope);
    scope.querySelectorAll && scope.querySelectorAll(SELECTOR).forEach(initFlight);
  }

  window[GLOBAL_KEY] = { initAll };
  initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const flights = [];
    if (event.target.matches && event.target.matches(SELECTOR)) flights.push(event.target);
    if (event.target.querySelectorAll) flights.push(...event.target.querySelectorAll(SELECTOR));
    flights.forEach((flight) => flight._kzFlightCleanup && flight._kzFlightCleanup());
  });
})();
